import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { DropdownSVG } from 'src/components/Icons/Basic'
import palette from 'src/designSystem/variables/palette'
import styled from 'styled-components/macro'

export const ShowPageAccordionIcon = styled(DropdownSVG).attrs({
  className: 'show-page-accordion-icon',
})<{ isActive: boolean }>`
  width: 20px;
  height: 20px;
  color: ${palette.neutral[900]};

  ${({ isActive }) =>
    isActive
      ? `
    transform: scaleY(-1);
    transition: transform 0.35s;
  `
      : `
    transform: scaleY(1);
    transition: transform 0.35s;
  `}
`

export const StyledShowPageAccordionIconOld = styled(FontAwesomeIcon)<{
  disabled?: boolean
}>`
  color: ${palette.neutral[600]};
  visibility: ${({ disabled }) => (disabled ? 'hidden' : 'visible')};
`
